import * as SearchActions from '~app/actions/search';
import makeReducer from '~app/core/makeReducer';

const initialState = {
  searchMarkers: [],
  searchLocations: [],
  locationInfoPromises: [],
  searchTerm: null,

  selectedLocation: null,
  selectedLocationInfo: null,

  comparisonLocation: null,
  comparisonLocationInfo: null,

  selectionMode: SearchActions.SelectionMode.select,
};

function setSearchTerm(state, {searchTerm}) {
  return {
    ...state,
    searchTerm,
  };
}

function dropPin(state, {marker, location, locationInfoPromise}) {
  return {
    ...state,
    searchMarkers: [...state.searchMarkers, marker],
    searchLocations: [...state.searchLocations, location],
    locationInfoPromises: [...state.locationInfoPromises, locationInfoPromise],
  };
}

function clearPin(state, {marker}) {
  const newSearchMarkers = [...state.searchMarkers];
  const newSearchLocations = [...state.searchLocations];
  const newLocationInfoPromises = [...state.locationInfoPromises];

  const index = newSearchMarkers.indexOf(marker);
  if (index !== -1) {
    newSearchMarkers.splice(index, 1);
    newSearchLocations.splice(index, 1);
    newLocationInfoPromises.splice(index, 1);
  }

  return {
    ...state,
    searchMarkers: newSearchMarkers,
    searchLocations: newSearchLocations,
    locationInfoPromises: newLocationInfoPromises,
  };
}

function clearPins(state) {
  return {
    ...state,
    searchMarkers: [],
    searchLocations: [],
    locationInfoPromises: [],
  };
}

function selectLocation(state, {location}) {
  return {
    ...state,
    selectedLocation: location,
  };
}

function selectLocationInfo(state, {locationInfo}) {
  return {
    ...state,
    selectedLocationInfo: locationInfo,
  };
}

function clearSelection(state) {
  return {
    ...state,
    selectedLocation: null,
    selectedLocationInfo: null,
  };
}

function setSelectionMode(state, {mode}) {
  return {
    ...state,
    selectionMode: mode,
  };
}

const ACTION_HANDLERS = {
  [SearchActions.SET_SEARCH_TERM]: setSearchTerm,

  [SearchActions.DROP_PIN]: dropPin,

  [SearchActions.CLEAR_PIN]: clearPin,
  [SearchActions.CLEAR_PINS]: clearPins,

  [SearchActions.SELECT_LOCATION]: selectLocation,
  [SearchActions.SELECT_LOCATION_INFO]: selectLocationInfo,
  [SearchActions.CLEAR_SELECTION]: clearSelection,

  [SearchActions.SET_SELECTION_MODE]: setSelectionMode,
};

export default makeReducer(ACTION_HANDLERS, initialState);



// WEBPACK FOOTER //
// ./src/store/searchReducer.js